let google = 'google.com'
let microsoft = 'microsoft.com'
export const OauthProviderIds = {
  GOOGLE: google,
  MICROSOFT: microsoft,
}

export const OauthProviderLabels = {
  [google]: 'Google',
  [microsoft]: 'Microsoft',
}

export const DEFAULT_OAUTH_SCOPES = {
  [google]: [
    'openid',
    'https://www.googleapis.com/auth/userinfo.profile',
    'https://www.googleapis.com/auth/userinfo.email',
  ],
  [microsoft]: [
    'openid',
    'profile',
    'email',
    'offline_access',
    'https://graph.microsoft.com/User.Read',
  ],
}

export const OauthProviderEndpoints = {
  [google]: 'https://accounts.google.com/o/oauth2/v2/auth',
  [microsoft]: 'https://login.microsoftonline.com/common/oauth2/v2.0/authorize',
}

export const OauthProviderCloudFunctions = {
  [google]: 'googleOauth2Callback',
  [microsoft]: 'microsoftOauth2Callback',
}

export const OauthClientIds = {
  [google]: process.env.VUE_APP_GAPI_CLIENT_ID || process.env.GAPI_CLIENT_ID,
  [microsoft]:
    process.env.VUE_APP_MICROSOFT_CLIENT_ID || process.env.MICROSOFT_CLIENT_ID,
}

export const OauthEnabledProviders = [
  OauthProviderIds.GOOGLE,
  OauthProviderIds.MICROSOFT, // TODO: Enable this when ready
]
